<template>
  <div class="post-navigation-link" :class="{ active: activePage }">
    <sc-link v-if="fields && fields.link" :field="fields.link" />
  </div>
</template>

<script>
import { Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-List-Page-Link',
  components: {
    ScLink: Link
  },
  props: {
    fields: {
      type: Object
    },
    postType: {
      type: Object
    }
  },
  computed: {
    activePage() {
      return (
        this.postType?.value?.toLowerCase().trim() ===
          this.fields?.link?.value?.text?.toLowerCase().trim() ||
        (this.fields?.link?.value?.text?.toLowerCase().indexOf('all') >= 0 &&
          this.postType?.value?.toLowerCase()?.indexOf('all') >= 0)
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.c-list__hero {
  .post-navigation {
    position: relative;
    padding-top: 2rem;

    &-link {
      display: inline-block;

      a {
        position: relative;
        display: inline-block;
        @include font-styles('Arial Narrow', 1.8rem, 500, normal, 3.2rem, 0, $white);
        text-transform: uppercase;
        margin-right: 2rem;

        &:hover {
          top: -0.3rem;
        }

        &.active {
          top: -0.3rem;
          border-bottom: solid 0.2rem $orange;
        }

        @include large-desktop-up {
          margin-right: 0;
        }
      }

      &.active {
        a {
          top: -0.3rem;
          border-bottom: solid 0.2rem $orange;
        }
      }

      &:last-child {
        a {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
